<template>
    <div class="mb-2" v-html="image"></div>
</template>

<script>
export default {
  props: ['image'],
}
</script>
